import styled from 'styled-components';

import { ScContainer } from '@/styles/common';
import { device, typography } from '@/styles/helpers';

export const ScHeadlineHero = styled.div`
  position: relative;
  z-index: 1;
  padding: 80px 0 23px;
  overflow: hidden;

  @media (${device.mobile}) {
    padding: 80px 0 4px;
  }

  ${ScContainer} {
    position: relative;
  }

  & .bonuses-notice-box {
    position: relative;
    z-index: 2;
    margin-block: 0px 16px;
    width: min(480px, 100%);
    margin-inline: auto;

    @media (${device.mobile}) {
      padding: 0 16px;
    }

    &:empty {
      display: none;
      margin: 0;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
    margin-bottom: 19px;
  }

  .title {
    ${typography.headline1}
    text-transform: uppercase;
    color: ${({ theme }) => theme.whiteColor};

    @media (${device.mobile}) {
      ${typography.headline2mobile}
    }
  }

  .description {
    ${typography.body2regular}
    color: ${({ theme }) => theme.whiteColor};
    max-width: 572px;
    margin: 0 auto;

    span {
      font-weight: 700;
    }
  }

  .regButton {
    max-width: 280px;
    margin: 0 auto;
  }
`;
